import { FiltersLayout } from 'shared/components/FiltersLayout';
import { useAvailableFilters } from 'shared/hooks';
import { ApplyFiltersButtonContainer } from '../ApplyFiltersButton';
import { TagsContainer } from '../TagsContainer';
import { FC } from 'react';
import { SaveSearchButtonContainer } from '../SaveSearchButtonContainer';
import { FILTERS_SET, FILTERS_MAP } from './constants';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { useSelector } from 'react-redux';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { EPageType } from 'shared/types/page';
import { FiltersLayoutForSearch } from 'shared/components/FiltersLayout/FiltersLayoutForSearch';

export const FiltersContainer: FC = () => {
  const filters = useAvailableFilters({ filtersSet: FILTERS_SET, filtersComponentsMap: FILTERS_MAP });
  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);
  const pageType = useSelector(selectPageType);

  if (isFiltersRedesignEnabled && pageType === EPageType.SEARCH) {
    return (
      <FiltersLayoutForSearch
        filters={filters}
        searchButton={<SaveSearchButtonContainer />}
        applyButton={<ApplyFiltersButtonContainer />}
        tags={<TagsContainer />}
      />
    );
  }

  return (
    <FiltersLayout
      isRedesign={isFiltersRedesignEnabled}
      filters={filters}
      searchButton={<SaveSearchButtonContainer />}
      applyButton={<ApplyFiltersButtonContainer />}
      tags={<TagsContainer />}
    />
  );
};
